<template>
	<div class="news-box">
		<div class="news-box-item" v-for="item in list" :key="item.id" @click="handleNewsDetail(item)">
			<div class="news-box-item-image">
				<img class="cover-img" :src="getNewsCover(item)" alt="" />
			</div>
			<div class="news-box-item-bottom">
				<div class="title text-overflow2">
					{{ item.title }}
				</div>
				<div class="time">{{ item.time }}</div>
			</div>
		</div>
	</div>
</template>
<script setup>
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useModuleDefaultCover } from '@rebuild/hooks/comp/useModuleDefaultCover';

defineProps({
	list: {
		type: Array,
		default: () => []
	}
});

const { viewModule } = useModuleNavigation();
const handleNewsDetail = item => {
	viewModule('news', item);
};

const { getDefaultCover } = useModuleDefaultCover();
const getNewsCover = item => {
	return item.image || getDefaultCover('news');
};
</script>
<style lang="less" scoped>
.news-box {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-gap: 13px;
	&-item {
		position: relative;
		height: 156px;
		&-image {
			position: relative;
			padding-top: 60%;
			.cover-img {
				position: absolute;
				top: 0;
				width: 100%;
				height: 100%;
				border-radius: 2px;
				background-color: #fff;
				object-fit: cover;
			}
		}
		&-bottom {
			padding: 4px 0;
			.title {
				color: #1d2129;

				font-size: 13px;

				font-weight: 500;
				line-height: 16px; /* 123.077% */
			}
			.time {
				position: absolute;
				bottom: 0;
				left: 0;
				color: var(--t-secondary-info-color, #86909c);

				font-size: 13px;

				font-weight: 400;
				line-height: normal;
			}
		}
	}
}
</style>
